import React from 'react';
import { useLocation, Switch, Route, Redirect, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import SubHeader from 'components/SubHeader';
import FooterBar from 'components/FooterBar';
import SettingsNav from './components/SettingsNav';
import RatePlan from './components/RatePlan';
import CouponCode from './components/CouponCode';
import HotelInfoAndPolicies from './components/HotelInfoAndPolicies';
import { Content, Container, NavContainer } from './styles';

const Settings = () => {

  const history = useHistory();
  const { pathname } = useLocation()

  return (
    <>
      <Helmet>
        <title>Settings - Rook Hotel PMS</title>
        <meta name="description" content="Settings - Rook Hotel PMS" />
      </Helmet>
      <SubHeader>
        <div className='title'>
          <a
            className='highlight'
            href='https://pms.rookhotel.com/settings'
            rel='noopener noreferrer'
            onClick={(event) => {
              // Handle special key combinations (Ctrl/Cmd+click)
              if (event.metaKey || event.ctrlKey) {
                // Allow default behavior (opens in new tab)
                return;
              }
              
              // Prevent default anchor behavior (full page reload)
              event.preventDefault();
              
              // Perform client-side navigation
              history.push('/settings');
            }}
          >
            Settings
          </a> 
          {(pathname.split('/')[2])? (' > ' + pathname.split('/')[2]): ''}
        </div>
      </SubHeader>
      <Content>
        <NavContainer>
          <SettingsNav />
        </NavContainer>
        <Container>
          <Switch>
            <Route
              path={'/settings/rate-plan'}
              render={() => <RatePlan />}
            />
            <Route
              path={'/settings/coupon-code'}
              render={() => <CouponCode />}
            />
            <Route
              path={'/settings/room-type-configuration'}
              render={() => <RatePlan />}
            />
            <Route
              path={'/settings/room-configuration'}
              render={() => <RatePlan />}
            />
            <Route
              path={'/settings/hotel-charges'}
              render={() => <RatePlan />}
            />
            <Route
              path={'/settings/hotel-info-and-policies'}
              render={() => <HotelInfoAndPolicies />}
            />
            <Redirect to={'/settings'} />
          </Switch>
        </Container>
      </Content>
      <FooterBar />
    </>
  );
};

export default Settings;